// extracted by mini-css-extract-plugin
export var bold = "section-alternate-grid-module--bold--2E+tZ";
export var box = "section-alternate-grid-module--box--07x8R";
export var button = "section-alternate-grid-module--button--EhbOw";
export var coloredBox = "section-alternate-grid-module--colored-box--bVtAn";
export var container = "section-alternate-grid-module--container--OCbxw";
export var content = "section-alternate-grid-module--content--C2Q61";
export var contentContainer = "section-alternate-grid-module--content-container--W7NgL";
export var display_table = "section-alternate-grid-module--display_table--Fa3K8";
export var heading = "section-alternate-grid-module--heading--2dfZm";
export var imageContainer = "section-alternate-grid-module--image-container--KYZxW";
export var imageSubTitle = "section-alternate-grid-module--image-sub-title--afuhh";
export var left = "section-alternate-grid-module--left--j-24a";
export var right = "section-alternate-grid-module--right--JpaXL";
export var tableBox = "section-alternate-grid-module--table-box--rVnI5";
export var textcenter = "section-alternate-grid-module--textcenter--Iv6Wu";
export var textright = "section-alternate-grid-module--textright--DpiDM";